export class UnauthorizedError extends Error {
  status: number;
  constructor() {
    super('Unauthorized');
    this.status = 401;
    this.name = 'UnauthorizedError';
    Object.setPrototypeOf(this, UnauthorizedError.prototype);
  }
}
